//#region src/assets/animations/flying-money-gt.json
var v = "4.8.0";
var w = 1080;
var h = 1080;
var assets = [];
var layers = [
	{
		"ind": 4,
		"ty": 4,
		"nm": "L",
		"sr": 1,
		"ks": {
			"o": {
				"a": 0,
				"k": 100
			},
			"r": {
				"a": 0,
				"k": 0
			},
			"p": {
				"a": 0,
				"k": [
					191.5,
					364,
					0
				]
			},
			"a": {
				"a": 0,
				"k": [
					116,
					223,
					0
				]
			},
			"s": {
				"a": 0,
				"k": [
					100,
					100,
					100
				]
			}
		},
		"shapes": [{
			"ty": "gr",
			"nm": "S",
			"bm": 0,
			"it": [
				{
					"ty": "sh",
					"nm": "P",
					"ind": 0,
					"ks": {
						"k": {
							"i": [[0, 0], [0, 0]],
							"o": [[0, 0], [0, 0]],
							"v": [[116, 218], [56, 280]],
							"c": false
						},
						"a": 0
					}
				},
				{
					"ty": "tm",
					"nm": "T",
					"s": {
						"a": 1,
						"k": [{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 3,
							"s": [0]
						}, {
							"t": 11,
							"s": [100]
						}]
					},
					"e": {
						"a": 1,
						"k": [{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 1,
							"s": [0]
						}, {
							"t": 6,
							"s": [100]
						}]
					},
					"o": {
						"a": 0,
						"k": 0
					},
					"m": 1
				},
				{
					"ty": "st",
					"nm": "S",
					"bm": 0,
					"lc": 2,
					"lj": 1,
					"ml": 4,
					"o": {
						"a": 0,
						"k": 100
					},
					"w": {
						"a": 0,
						"k": 20
					},
					"c": {
						"a": 0,
						"k": [
							.309803981407,
							.482353001015,
							1,
							1
						]
					}
				},
				{
					"ty": "tr",
					"o": {
						"a": 0,
						"k": 100
					},
					"r": {
						"a": 0,
						"k": 0
					},
					"p": {
						"a": 0,
						"k": [0, 0]
					},
					"a": {
						"a": 0,
						"k": [0, 0]
					},
					"s": {
						"a": 0,
						"k": [100, 100]
					},
					"nm": "T",
					"sk": {
						"a": 0,
						"k": 0
					},
					"sa": {
						"a": 0,
						"k": 0
					}
				}
			]
		}],
		"ip": 0,
		"op": 720,
		"st": 0
	},
	{
		"ind": 5,
		"ty": 4,
		"nm": "L",
		"sr": 1,
		"ks": {
			"o": {
				"a": 0,
				"k": 100
			},
			"r": {
				"a": 0,
				"k": 0
			},
			"p": {
				"a": 0,
				"k": [
					633.5,
					760,
					0
				]
			},
			"a": {
				"a": 0,
				"k": [
					116,
					223,
					0
				]
			},
			"s": {
				"a": 0,
				"k": [
					100,
					100,
					100
				]
			}
		},
		"shapes": [{
			"ty": "gr",
			"nm": "S",
			"bm": 0,
			"it": [
				{
					"ty": "sh",
					"nm": "P",
					"ind": 0,
					"ks": {
						"k": {
							"i": [[0, 0], [0, 0]],
							"o": [[0, 0], [0, 0]],
							"v": [[116, 218], [56, 280]],
							"c": false
						},
						"a": 0
					}
				},
				{
					"ty": "tm",
					"nm": "T",
					"s": {
						"a": 1,
						"k": [{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 3,
							"s": [0]
						}, {
							"t": 11,
							"s": [100]
						}]
					},
					"e": {
						"a": 1,
						"k": [{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 1,
							"s": [0]
						}, {
							"t": 6,
							"s": [100]
						}]
					},
					"o": {
						"a": 0,
						"k": 0
					},
					"m": 1
				},
				{
					"ty": "st",
					"nm": "S",
					"bm": 0,
					"lc": 2,
					"lj": 1,
					"ml": 4,
					"o": {
						"a": 0,
						"k": 100
					},
					"w": {
						"a": 0,
						"k": 20
					},
					"c": {
						"a": 0,
						"k": [
							.309803981407,
							.482353001015,
							1,
							1
						]
					}
				},
				{
					"ty": "tr",
					"o": {
						"a": 0,
						"k": 100
					},
					"r": {
						"a": 0,
						"k": 0
					},
					"p": {
						"a": 0,
						"k": [0, 0]
					},
					"a": {
						"a": 0,
						"k": [0, 0]
					},
					"s": {
						"a": 0,
						"k": [100, 100]
					},
					"nm": "T",
					"sk": {
						"a": 0,
						"k": 0
					},
					"sa": {
						"a": 0,
						"k": 0
					}
				}
			]
		}],
		"ip": 0,
		"op": 720,
		"st": 0
	},
	{
		"ind": 6,
		"ty": 4,
		"nm": "L",
		"sr": 1,
		"ks": {
			"o": {
				"a": 0,
				"k": 100
			},
			"r": {
				"a": 0,
				"k": 0
			},
			"p": {
				"a": 0,
				"k": [
					238.5,
					416.5,
					0
				]
			},
			"a": {
				"a": 0,
				"k": [
					162.5,
					190.5,
					0
				]
			},
			"s": {
				"a": 0,
				"k": [
					100,
					100,
					100
				]
			}
		},
		"shapes": [{
			"ty": "gr",
			"nm": "S",
			"bm": 0,
			"it": [
				{
					"ty": "sh",
					"nm": "P",
					"ind": 0,
					"ks": {
						"k": {
							"i": [[0, 0], [0, 0]],
							"o": [[0, 0], [0, 0]],
							"v": [[159, 187], [62, 286]],
							"c": false
						},
						"a": 0
					}
				},
				{
					"ty": "st",
					"nm": "S",
					"bm": 0,
					"lc": 2,
					"lj": 1,
					"ml": 4,
					"o": {
						"a": 0,
						"k": 100
					},
					"w": {
						"a": 0,
						"k": 20
					},
					"c": {
						"a": 0,
						"k": [
							.309803981407,
							.482353001015,
							1,
							1
						]
					}
				},
				{
					"ty": "tm",
					"nm": "T",
					"s": {
						"a": 1,
						"k": [{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 3,
							"s": [0]
						}, {
							"t": 11,
							"s": [100]
						}]
					},
					"e": {
						"a": 1,
						"k": [{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 1,
							"s": [0]
						}, {
							"t": 6,
							"s": [100]
						}]
					},
					"o": {
						"a": 0,
						"k": 0
					},
					"m": 1
				},
				{
					"ty": "tr",
					"o": {
						"a": 0,
						"k": 100
					},
					"r": {
						"a": 0,
						"k": 0
					},
					"p": {
						"a": 0,
						"k": [0, 0]
					},
					"a": {
						"a": 0,
						"k": [0, 0]
					},
					"s": {
						"a": 0,
						"k": [100, 100]
					},
					"nm": "T",
					"sk": {
						"a": 0,
						"k": 0
					},
					"sa": {
						"a": 0,
						"k": 0
					}
				}
			]
		}],
		"ip": 0,
		"op": 720,
		"st": 0
	},
	{
		"ind": 7,
		"ty": 4,
		"nm": "L",
		"sr": 1,
		"ks": {
			"o": {
				"a": 0,
				"k": 100
			},
			"r": {
				"a": 0,
				"k": 0
			},
			"p": {
				"a": 0,
				"k": [
					680.5,
					812.5,
					0
				]
			},
			"a": {
				"a": 0,
				"k": [
					162.5,
					190.5,
					0
				]
			},
			"s": {
				"a": 0,
				"k": [
					100,
					100,
					100
				]
			}
		},
		"shapes": [{
			"ty": "gr",
			"nm": "S",
			"bm": 0,
			"it": [
				{
					"ty": "sh",
					"nm": "P",
					"ind": 0,
					"ks": {
						"k": {
							"i": [[0, 0], [0, 0]],
							"o": [[0, 0], [0, 0]],
							"v": [[159, 187], [62, 286]],
							"c": false
						},
						"a": 0
					}
				},
				{
					"ty": "st",
					"nm": "S",
					"bm": 0,
					"lc": 2,
					"lj": 1,
					"ml": 4,
					"o": {
						"a": 0,
						"k": 100
					},
					"w": {
						"a": 0,
						"k": 20
					},
					"c": {
						"a": 0,
						"k": [
							.309803981407,
							.482353001015,
							1,
							1
						]
					}
				},
				{
					"ty": "tm",
					"nm": "T",
					"s": {
						"a": 1,
						"k": [{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 3,
							"s": [0]
						}, {
							"t": 11,
							"s": [100]
						}]
					},
					"e": {
						"a": 1,
						"k": [{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 1,
							"s": [0]
						}, {
							"t": 6,
							"s": [100]
						}]
					},
					"o": {
						"a": 0,
						"k": 0
					},
					"m": 1
				},
				{
					"ty": "tr",
					"o": {
						"a": 0,
						"k": 100
					},
					"r": {
						"a": 0,
						"k": 0
					},
					"p": {
						"a": 0,
						"k": [0, 0]
					},
					"a": {
						"a": 0,
						"k": [0, 0]
					},
					"s": {
						"a": 0,
						"k": [100, 100]
					},
					"nm": "T",
					"sk": {
						"a": 0,
						"k": 0
					},
					"sa": {
						"a": 0,
						"k": 0
					}
				}
			]
		}],
		"ip": 0,
		"op": 720,
		"st": 0
	},
	{
		"ind": 8,
		"ty": 4,
		"nm": "L",
		"sr": 1,
		"ks": {
			"o": {
				"a": 0,
				"k": 100
			},
			"r": {
				"a": 0,
				"k": 0
			},
			"p": {
				"a": 0,
				"k": [
					289,
					469.5,
					0
				]
			},
			"a": {
				"a": 0,
				"k": [
					116,
					223,
					0
				]
			},
			"s": {
				"a": 0,
				"k": [
					100,
					100,
					100
				]
			}
		},
		"shapes": [{
			"ty": "gr",
			"nm": "S",
			"bm": 0,
			"it": [
				{
					"ty": "sh",
					"nm": "P",
					"ind": 0,
					"ks": {
						"k": {
							"i": [[0, 0], [0, 0]],
							"o": [[0, 0], [0, 0]],
							"v": [[116, 218], [56, 280]],
							"c": false
						},
						"a": 0
					}
				},
				{
					"ty": "st",
					"nm": "S",
					"bm": 0,
					"lc": 2,
					"lj": 1,
					"ml": 4,
					"o": {
						"a": 0,
						"k": 100
					},
					"w": {
						"a": 0,
						"k": 20
					},
					"c": {
						"a": 0,
						"k": [
							.309803981407,
							.482353001015,
							1,
							1
						]
					}
				},
				{
					"ty": "tm",
					"nm": "T",
					"s": {
						"a": 1,
						"k": [{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 3,
							"s": [0]
						}, {
							"t": 11,
							"s": [100]
						}]
					},
					"e": {
						"a": 1,
						"k": [{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 1,
							"s": [0]
						}, {
							"t": 6,
							"s": [100]
						}]
					},
					"o": {
						"a": 0,
						"k": 0
					},
					"m": 1
				},
				{
					"ty": "tr",
					"o": {
						"a": 0,
						"k": 100
					},
					"r": {
						"a": 0,
						"k": 0
					},
					"p": {
						"a": 0,
						"k": [0, 0]
					},
					"a": {
						"a": 0,
						"k": [0, 0]
					},
					"s": {
						"a": 0,
						"k": [100, 100]
					},
					"nm": "T",
					"sk": {
						"a": 0,
						"k": 0
					},
					"sa": {
						"a": 0,
						"k": 0
					}
				}
			]
		}],
		"ip": 0,
		"op": 720,
		"st": 0
	},
	{
		"ind": 9,
		"ty": 4,
		"nm": "L",
		"sr": 1,
		"ks": {
			"o": {
				"a": 0,
				"k": 100
			},
			"r": {
				"a": 0,
				"k": 0
			},
			"p": {
				"a": 0,
				"k": [
					731,
					865.5,
					0
				]
			},
			"a": {
				"a": 0,
				"k": [
					116,
					223,
					0
				]
			},
			"s": {
				"a": 0,
				"k": [
					100,
					100,
					100
				]
			}
		},
		"shapes": [{
			"ty": "gr",
			"nm": "S",
			"bm": 0,
			"it": [
				{
					"ty": "sh",
					"nm": "P",
					"ind": 0,
					"ks": {
						"k": {
							"i": [[0, 0], [0, 0]],
							"o": [[0, 0], [0, 0]],
							"v": [[116, 218], [56, 280]],
							"c": false
						},
						"a": 0
					}
				},
				{
					"ty": "st",
					"nm": "S",
					"bm": 0,
					"lc": 2,
					"lj": 1,
					"ml": 4,
					"o": {
						"a": 0,
						"k": 100
					},
					"w": {
						"a": 0,
						"k": 20
					},
					"c": {
						"a": 0,
						"k": [
							.309803981407,
							.482353001015,
							1,
							1
						]
					}
				},
				{
					"ty": "tm",
					"nm": "T",
					"s": {
						"a": 1,
						"k": [{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 3,
							"s": [0]
						}, {
							"t": 11,
							"s": [100]
						}]
					},
					"e": {
						"a": 1,
						"k": [{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 1,
							"s": [0]
						}, {
							"t": 6,
							"s": [100]
						}]
					},
					"o": {
						"a": 0,
						"k": 0
					},
					"m": 1
				},
				{
					"ty": "tr",
					"o": {
						"a": 0,
						"k": 100
					},
					"r": {
						"a": 0,
						"k": 0
					},
					"p": {
						"a": 0,
						"k": [0, 0]
					},
					"a": {
						"a": 0,
						"k": [0, 0]
					},
					"s": {
						"a": 0,
						"k": [100, 100]
					},
					"nm": "T",
					"sk": {
						"a": 0,
						"k": 0
					},
					"sa": {
						"a": 0,
						"k": 0
					}
				}
			]
		}],
		"ip": 0,
		"op": 720,
		"st": 0
	},
	{
		"ind": 10,
		"ty": 4,
		"nm": "B",
		"sr": 1,
		"ks": {
			"o": {
				"a": 0,
				"k": 100
			},
			"r": {
				"a": 0,
				"k": 0
			},
			"p": {
				"k": [
					{
						"i": {
							"x": .667,
							"y": 1
						},
						"o": {
							"x": .333,
							"y": 0
						},
						"t": 0,
						"s": [
							610,
							460,
							0
						],
						"ti": [
							0,
							0,
							0
						],
						"to": [
							0,
							0,
							0
						]
					},
					{
						"i": {
							"x": .667,
							"y": 1
						},
						"o": {
							"x": .333,
							"y": 0
						},
						"t": 7,
						"s": [
							640,
							430,
							0
						],
						"ti": [
							0,
							0,
							0
						],
						"to": [
							0,
							0,
							0
						]
					},
					{
						"t": 35,
						"s": [
							610,
							460,
							0
						]
					}
				],
				"a": 1
			},
			"a": {
				"a": 0,
				"k": [
					495.707,
					285.07,
					0
				]
			},
			"s": {
				"a": 0,
				"k": [
					100,
					100,
					100
				]
			}
		},
		"shapes": [
			{
				"ty": "gr",
				"nm": "Q",
				"bm": 0,
				"it": [
					{
						"ty": "sh",
						"nm": "P",
						"ind": 0,
						"ks": {
							"k": {
								"i": [
									[.123, -6.489],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[18.018, 18.018],
									[-13.075, 17.784],
									[-19.068, -19.367],
									[-2.473, -6.001]
								],
								"o": [
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0],
									[-18.168, 18.168],
									[-16.35, -16.35],
									[16.136, -21.87],
									[4.66, 4.517],
									[2.474, 6]
								],
								"v": [
									[31.865, 4.583],
									[5.03, -1.965],
									[-1.969, 25.277],
									[20.951, 31.076],
									[19.539, 32.488],
									[-43.397, 29.986],
									[-50.224, -27.602],
									[17.484, -30.298],
									[28.299, -14.352]
								],
								"c": true
							},
							"a": 0
						}
					},
					{
						"ty": "sh",
						"nm": "P",
						"ind": 1,
						"ks": {
							"k": {
								"i": [
									[0, 0],
									[3.892, 11.765],
									[8.781, 8.744],
									[20.718, .128],
									[14.792, -14.509],
									[3.895, -9.521],
									[-.049, -10.286],
									[-3.987, -9.481],
									[-7.316, -7.232],
									[-9.496, -4.018],
									[-10.31, -.073],
									[-9.551, 3.883],
									[-7.335, 7.245],
									[-3.391, 5.889],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								"o": [
									[1.833, -12.256],
									[-3.892, -11.765],
									[-14.61, -14.691],
									[-20.718, -.128],
									[-7.244, 7.302],
									[-3.895, 9.52],
									[.05, 10.287],
									[3.987, 9.483],
									[7.231, 7.349],
									[9.495, 4.018],
									[10.311, .074],
									[9.552, -3.882],
									[4.819, -4.793],
									[0, 0],
									[0, 0],
									[0, 0],
									[0, 0]
								],
								"v": [
									[64.263, 12.587],
									[61.133, -23.947],
									[41.857, -55.142],
									[-13.297, -78.277],
									[-68.736, -55.827],
									[-85.609, -30.347],
									[-91.435, -.345],
									[-85.32, 29.598],
									[-68.199, 54.915],
									[-42.863, 72.134],
									[-12.865, 78.332],
									[17.221, 72.562],
									[42.799, 55.707],
									[55.169, 39.615],
									[84.656, 46.934],
									[91.484, 19.521],
									[64.2, 12.823]
								],
								"c": true
							},
							"a": 0
						}
					},
					{
						"ty": "mm",
						"nm": "M",
						"mm": 1
					},
					{
						"ty": "fl",
						"nm": "F",
						"bm": 0,
						"c": {
							"a": 0,
							"k": [
								.309803921569,
								.482352971096,
								1,
								1
							]
						},
						"o": {
							"a": 0,
							"k": 100
						},
						"r": 1
					},
					{
						"ty": "tr",
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [501.385, 275.919]
						},
						"a": {
							"a": 0,
							"k": [0, 0]
						},
						"s": {
							"a": 0,
							"k": [100, 100]
						},
						"nm": "T",
						"sk": {
							"a": 0,
							"k": 0
						},
						"sa": {
							"a": 0,
							"k": 0
						}
					}
				]
			},
			{
				"ty": "gr",
				"nm": "C",
				"bm": 0,
				"it": [
					{
						"ty": "gr",
						"nm": "G",
						"bm": 0,
						"it": [
							{
								"ty": "sh",
								"nm": "P",
								"ind": 0,
								"ks": {
									"k": {
										"i": [
											[-.01, -.47],
											[.17, -.44],
											[.33, -.33],
											[0, 0],
											[6.9, 0],
											[4.88, 4.88],
											[0, 0],
											[.18, .43],
											[-.01, .48],
											[-.2, .43],
											[-.34, .32],
											[-18.64, 0],
											[-13.81, -12.53],
											[-.19, -.43]
										],
										"o": [
											[.01, .48],
											[-.17, .44],
											[0, 0],
											[-4.88, 4.88],
											[-6.9, 0],
											[0, 0],
											[-.34, -.33],
											[-.18, -.44],
											[0, -.47],
											[.19, -.43],
											[13.81, -12.53],
											[18.64, .01],
											[.34, .32],
											[.2, .44]
										],
										"v": [
											[51.535, -10.155],
											[51.285, -8.765],
											[50.515, -7.595],
											[18.415, 24.505],
											[.015, 32.135],
											[-18.385, 24.505],
											[-50.485, -7.595],
											[-51.275, -8.755],
											[-51.535, -10.145],
											[-51.235, -11.515],
											[-50.425, -12.665],
											[-.005, -32.135],
											[50.415, -12.665],
											[51.225, -11.525]
										],
										"c": true
									},
									"a": 0
								}
							},
							{
								"ty": "fl",
								"nm": "F",
								"bm": 0,
								"c": {
									"a": 0,
									"k": [
										.309803921569,
										.482352971096,
										1,
										1
									]
								},
								"o": {
									"a": 0,
									"k": 100
								},
								"r": 1
							},
							{
								"ty": "tr",
								"o": {
									"a": 0,
									"k": 100
								},
								"r": {
									"a": 0,
									"k": 0
								},
								"p": {
									"a": 0,
									"k": [409.012, 503.95]
								},
								"a": {
									"a": 0,
									"k": [0, 0]
								},
								"s": {
									"a": 0,
									"k": [100, 100]
								},
								"nm": "T",
								"sk": {
									"a": 0,
									"k": 0
								},
								"sa": {
									"a": 0,
									"k": 0
								}
							}
						]
					},
					{
						"ty": "gr",
						"nm": "G",
						"bm": 0,
						"it": [
							{
								"ty": "sh",
								"nm": "P",
								"ind": 0,
								"ks": {
									"k": {
										"i": [
											[0, -18.64],
											[12.52, -13.8],
											[.43, -.19],
											[.47, -.01],
											[.44, .18],
											[.34, .33],
											[0, 0],
											[1.32, 3.16],
											[.01, 3.42],
											[-1.31, 3.16],
											[-2.42, 2.41],
											[0, 0],
											[-.44, .18],
											[-.47, -.01],
											[-.43, -.18],
											[-.32, -.34]
										],
										"o": [
											[0, 18.64],
											[-.32, .35],
											[-.43, .19],
											[-.47, 0],
											[-.44, -.17],
											[0, 0],
											[-2.42, -2.41],
											[-1.31, -3.16],
											[0, -3.41],
											[1.31, -3.15],
											[0, 0],
											[.33, -.34],
											[.44, -.18],
											[.47, 0],
											[.43, .19],
											[12.52, 13.81]
										],
										"v": [
											[32.13, .005],
											[12.67, 50.415],
											[11.53, 51.225],
											[10.16, 51.525],
											[8.79, 51.265],
											[7.62, 50.505],
											[-24.48, 18.405],
											[-30.14, 9.975],
											[-32.13, .015],
											[-30.15, -9.945],
											[-24.5, -18.375],
											[7.6, -50.475],
											[8.77, -51.255],
											[10.15, -51.515],
											[11.52, -51.225],
											[12.67, -50.415]
										],
										"c": true
									},
									"a": 0
								}
							},
							{
								"ty": "fl",
								"nm": "F",
								"bm": 0,
								"c": {
									"a": 0,
									"k": [
										.309803921569,
										.482352971096,
										1,
										1
									]
								},
								"o": {
									"a": 0,
									"k": 100
								},
								"r": 1
							},
							{
								"ty": "tr",
								"o": {
									"a": 0,
									"k": 100
								},
								"r": {
									"a": 0,
									"k": 0
								},
								"p": {
									"a": 0,
									"k": [273.137, 368]
								},
								"a": {
									"a": 0,
									"k": [0, 0]
								},
								"s": {
									"a": 0,
									"k": [100, 100]
								},
								"nm": "T",
								"sk": {
									"a": 0,
									"k": 0
								},
								"sa": {
									"a": 0,
									"k": 0
								}
							}
						]
					},
					{
						"ty": "gr",
						"nm": "B",
						"bm": 0,
						"it": [
							{
								"ty": "sh",
								"nm": "P",
								"ind": 0,
								"ks": {
									"k": {
										"i": [
											[1.3, -3.16],
											[2.42, -2.42],
											[0, 0],
											[.44, -.18],
											[.47, .01],
											[.43, .19],
											[.32, .35],
											[0, 18.64],
											[-12.53, 13.8],
											[-.43, .19],
											[-.47, 0],
											[-.44, -.18],
											[-.34, -.33],
											[0, 0],
											[-1.31, -3.15],
											[0, -3.42]
										],
										"o": [
											[-1.31, 3.16],
											[0, 0],
											[-.33, .34],
											[-.43, .19],
											[-.48, 0],
											[-.43, -.2],
											[-12.53, -13.8],
											[0, -18.65],
											[.32, -.34],
											[.43, -.18],
											[.47, -.01],
											[.43, .17],
											[0, 0],
											[2.42, 2.41],
											[1.32, 3.16],
											[.01, 3.42]
										],
										"v": [
											[249.19, -76.865],
											[243.54, -68.425],
											[211.44, -36.325],
											[210.27, -35.535],
											[208.89, -35.265],
											[207.51, -35.565],
											[206.37, -36.395],
											[186.9, -86.805],
											[206.37, -137.225],
											[207.51, -138.035],
											[208.87, -138.325],
											[210.25, -138.075],
											[211.42, -137.315],
											[243.52, -105.215],
											[249.17, -96.785],
											[251.16, -86.825]
										],
										"c": true
									},
									"a": 0
								}
							},
							{
								"ty": "sh",
								"nm": "P",
								"ind": 1,
								"ks": {
									"k": {
										"i": [
											[.2, -.44],
											[.35, -.32],
											[18.64, 0],
											[13.81, 12.53],
											[.19, .43],
											[.01, .47],
											[-.17, .44],
											[-.33, .34],
											[0, 0],
											[-3.16, 1.32],
											[-3.42, 0],
											[-3.15, -1.31],
											[-2.41, -2.42],
											[0, 0],
											[-.19, -.43],
											[0, -.48]
										],
										"o": [
											[-.19, .43],
											[-13.81, 12.53],
											[-18.64, 0],
											[-.34, -.32],
											[-.19, -.43],
											[-.01, -.47],
											[.18, -.44],
											[0, 0],
											[2.41, -2.42],
											[3.15, -1.31],
											[3.41, 0],
											[3.16, 1.31],
											[0, 0],
											[.34, .33],
											[.18, .44],
											[-.01, .47]
										],
										"v": [
											[134.26, -211.295],
											[133.44, -210.155],
											[83.02, -190.685],
											[32.6, -210.155],
											[31.8, -211.295],
											[31.5, -212.665],
											[31.75, -214.035],
											[32.52, -215.205],
											[64.62, -247.305],
											[73.05, -252.965],
											[83.01, -254.955],
											[92.96, -252.975],
											[101.4, -247.325],
											[133.5, -215.225],
											[134.3, -214.065],
											[134.57, -212.675]
										],
										"c": true
									},
									"a": 0
								}
							},
							{
								"ty": "sh",
								"nm": "P",
								"ind": 2,
								"ks": {
									"k": {
										"i": [
											[.17, -.44],
											[.33, -.33],
											[0, 0],
											[6.9, 0],
											[4.88, 4.88],
											[0, 0],
											[.18, .43],
											[-.01, .48],
											[-.2, .43],
											[-.34, .32],
											[-18.64, 0],
											[-13.81, -12.53],
											[-.19, -.43],
											[-.01, -.47]
										],
										"o": [
											[-.17, .44],
											[0, 0],
											[-4.88, 4.88],
											[-6.9, 0],
											[0, 0],
											[-.34, -.33],
											[-.18, -.44],
											[0, -.47],
											[.19, -.43],
											[13.81, -12.53],
											[18.64, .01],
											[.34, .32],
											[.2, .44],
											[.01, .48]
										],
										"v": [
											[-35.41, 210.115],
											[-36.18, 211.285],
											[-68.28, 243.385],
											[-86.68, 251.015],
											[-105.08, 243.385],
											[-137.18, 211.285],
											[-137.97, 210.125],
											[-138.23, 208.735],
											[-137.93, 207.365],
											[-137.12, 206.215],
											[-86.7, 186.745],
											[-36.28, 206.215],
											[-35.47, 207.355],
											[-35.16, 208.725]
										],
										"c": true
									},
									"a": 0
								}
							},
							{
								"ty": "sh",
								"nm": "P",
								"ind": 3,
								"ks": {
									"k": {
										"i": [
											[12.52, -13.8],
											[.43, -.19],
											[.47, -.01],
											[.44, .18],
											[.34, .33],
											[0, 0],
											[1.32, 3.16],
											[.01, 3.42],
											[-1.31, 3.16],
											[-2.42, 2.41],
											[0, 0],
											[-.44, .18],
											[-.47, -.01],
											[-.43, -.18],
											[-.32, -.34],
											[0, -18.64]
										],
										"o": [
											[-.32, .35],
											[-.43, .19],
											[-.47, 0],
											[-.44, -.17],
											[0, 0],
											[-2.42, -2.41],
											[-1.31, -3.16],
											[0, -3.41],
											[1.31, -3.15],
											[0, 0],
											[.33, -.34],
											[.44, -.18],
											[.47, 0],
											[.43, .19],
											[12.52, 13.81],
											[0, 18.64]
										],
										"v": [
											[-209.9, 133.345],
											[-211.04, 134.155],
											[-212.41, 134.455],
											[-213.78, 134.195],
											[-214.95, 133.435],
											[-247.05, 101.335],
											[-252.71, 92.905],
											[-254.7, 82.945],
											[-252.72, 72.985],
											[-247.07, 64.555],
											[-214.97, 32.455],
											[-213.8, 31.675],
											[-212.42, 31.415],
											[-211.05, 31.705],
											[-209.9, 32.515],
											[-190.44, 82.935]
										],
										"c": true
									},
									"a": 0
								}
							},
							{
								"ty": "sh",
								"nm": "P",
								"ind": 4,
								"ks": {
									"k": {
										"i": [
											[17.63, 17.63],
											[0, 0],
											[17.62, -17.62],
											[0, 0],
											[-17.62, -17.63],
											[0, 0],
											[-17.63, 17.62],
											[0, 0]
										],
										"o": [
											[0, 0],
											[-17.62, -17.62],
											[0, 0],
											[-17.62, 17.62],
											[0, 0],
											[17.62, 17.62],
											[0, 0],
											[17.63, -17.62]
										],
										"v": [
											[251.86, -115.835],
											[115.83, -251.865],
											[51.91, -251.865],
											[-251.87, 51.915],
											[-251.87, 115.835],
											[-115.83, 251.865],
											[-51.91, 251.865],
											[251.86, -51.915]
										],
										"c": true
									},
									"a": 0
								}
							},
							{
								"ty": "fl",
								"nm": "F",
								"bm": 0,
								"c": {
									"a": 0,
									"k": [
										1,
										1,
										1,
										1
									]
								},
								"o": {
									"a": 0,
									"k": 100
								},
								"r": 1
							},
							{
								"ty": "tr",
								"o": {
									"a": 0,
									"k": 100
								},
								"r": {
									"a": 0,
									"k": 0
								},
								"p": {
									"a": 0,
									"k": [495.707, 285.07]
								},
								"a": {
									"a": 0,
									"k": [0, 0]
								},
								"s": {
									"a": 0,
									"k": [100, 100]
								},
								"nm": "T",
								"sk": {
									"a": 0,
									"k": 0
								},
								"sa": {
									"a": 0,
									"k": 0
								}
							}
						]
					},
					{
						"ty": "gr",
						"nm": "G",
						"bm": 0,
						"it": [
							{
								"ty": "sh",
								"nm": "P",
								"ind": 0,
								"ks": {
									"k": {
										"i": [
											[0, -3.42],
											[1.3, -3.16],
											[2.42, -2.42],
											[0, 0],
											[.44, -.18],
											[.47, .01],
											[.43, .19],
											[.32, .35],
											[0, 18.64],
											[-12.53, 13.8],
											[-.43, .19],
											[-.47, 0],
											[-.44, -.18],
											[-.34, -.33],
											[0, 0],
											[-1.31, -3.15]
										],
										"o": [
											[.01, 3.42],
											[-1.31, 3.16],
											[0, 0],
											[-.33, .34],
											[-.43, .19],
											[-.48, 0],
											[-.43, -.2],
											[-12.53, -13.8],
											[0, -18.65],
											[.32, -.34],
											[.43, -.18],
											[.47, -.01],
											[.43, .17],
											[0, 0],
											[2.42, 2.41],
											[1.32, 3.16]
										],
										"v": [
											[32.125, -.03],
											[30.155, 9.93],
											[24.505, 18.37],
											[-7.595, 50.47],
											[-8.765, 51.26],
											[-10.145, 51.53],
											[-11.525, 51.23],
											[-12.665, 50.4],
											[-32.135, -.01],
											[-12.665, -50.43],
											[-11.525, -51.24],
											[-10.165, -51.53],
											[-8.785, -51.28],
											[-7.615, -50.52],
											[24.485, -18.42],
											[30.135, -9.99]
										],
										"c": true
									},
									"a": 0
								}
							},
							{
								"ty": "fl",
								"nm": "F",
								"bm": 0,
								"c": {
									"a": 0,
									"k": [
										.309803921569,
										.482352971096,
										1,
										1
									]
								},
								"o": {
									"a": 0,
									"k": 100
								},
								"r": 1
							},
							{
								"ty": "tr",
								"o": {
									"a": 0,
									"k": 100
								},
								"r": {
									"a": 0,
									"k": 0
								},
								"p": {
									"a": 0,
									"k": [714.742, 198.275]
								},
								"a": {
									"a": 0,
									"k": [0, 0]
								},
								"s": {
									"a": 0,
									"k": [100, 100]
								},
								"nm": "T",
								"sk": {
									"a": 0,
									"k": 0
								},
								"sa": {
									"a": 0,
									"k": 0
								}
							}
						]
					},
					{
						"ty": "gr",
						"nm": "G",
						"bm": 0,
						"it": [
							{
								"ty": "sh",
								"nm": "P",
								"ind": 0,
								"ks": {
									"k": {
										"i": [
											[0, -.48],
											[.2, -.44],
											[.35, -.32],
											[18.64, 0],
											[13.81, 12.53],
											[.19, .43],
											[.01, .47],
											[-.17, .44],
											[-.33, .34],
											[0, 0],
											[-3.16, 1.32],
											[-3.42, 0],
											[-3.15, -1.31],
											[-2.41, -2.42],
											[0, 0],
											[-.19, -.43]
										],
										"o": [
											[-.01, .47],
											[-.19, .43],
											[-13.81, 12.53],
											[-18.64, 0],
											[-.34, -.32],
											[-.19, -.43],
											[-.01, -.47],
											[.18, -.44],
											[0, 0],
											[2.41, -2.42],
											[3.15, -1.31],
											[3.41, 0],
											[3.16, 1.31],
											[0, 0],
											[.34, .33],
											[.18, .44]
										],
										"v": [
											[51.54, 10.145],
											[51.23, 11.525],
											[50.41, 12.665],
											[-.01, 32.135],
											[-50.43, 12.665],
											[-51.23, 11.525],
											[-51.53, 10.155],
											[-51.28, 8.785],
											[-50.51, 7.615],
											[-18.41, -24.485],
											[-9.98, -30.145],
											[-.02, -32.135],
											[9.93, -30.155],
											[18.37, -24.505],
											[50.47, 7.595],
											[51.27, 8.755]
										],
										"c": true
									},
									"a": 0
								}
							},
							{
								"ty": "fl",
								"nm": "F",
								"bm": 0,
								"c": {
									"a": 0,
									"k": [
										.309803921569,
										.482352971096,
										1,
										1
									]
								},
								"o": {
									"a": 0,
									"k": 100
								},
								"r": 1
							},
							{
								"ty": "tr",
								"o": {
									"a": 0,
									"k": 100
								},
								"r": {
									"a": 0,
									"k": 0
								},
								"p": {
									"a": 0,
									"k": [578.737, 62.25]
								},
								"a": {
									"a": 0,
									"k": [0, 0]
								},
								"s": {
									"a": 0,
									"k": [100, 100]
								},
								"nm": "T",
								"sk": {
									"a": 0,
									"k": 0
								},
								"sa": {
									"a": 0,
									"k": 0
								}
							}
						]
					},
					{
						"ty": "tr",
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [495.706, 285.07]
						},
						"a": {
							"a": 0,
							"k": [495.706, 285.07]
						},
						"s": {
							"a": 0,
							"k": [100, 100]
						},
						"nm": "T",
						"sk": {
							"a": 0,
							"k": 0
						},
						"sa": {
							"a": 0,
							"k": 0
						}
					}
				]
			},
			{
				"ty": "gr",
				"nm": "B",
				"bm": 0,
				"it": [
					{
						"ty": "sh",
						"nm": "P",
						"ind": 0,
						"ks": {
							"k": {
								"i": [
									[25.42, 25.42],
									[0, 0],
									[25.42, -25.42],
									[0, 0],
									[-25.42, -25.42],
									[0, 0],
									[-25.42, 25.42],
									[0, 0]
								],
								"o": [
									[0, 0],
									[-25.42, -25.42],
									[0, 0],
									[-25.42, 25.43],
									[0, 0],
									[25.43, 25.42],
									[0, 0],
									[25.42, -25.43]
								],
								"v": [
									[269.188, -133.152],
									[133.148, -269.182],
									[40.948, -269.182],
									[-262.832, 34.588],
									[-262.832, 126.798],
									[-126.802, 262.828],
									[-34.592, 262.828],
									[269.188, -40.942]
								],
								"c": true
							},
							"a": 0
						}
					},
					{
						"ty": "fl",
						"nm": "F",
						"bm": 0,
						"c": {
							"a": 0,
							"k": [
								.211764720842,
								.250980392157,
								.286274509804,
								1
							]
						},
						"o": {
							"a": 0,
							"k": 100
						},
						"r": 1
					},
					{
						"ty": "tr",
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [492.53, 288.248]
						},
						"a": {
							"a": 0,
							"k": [0, 0]
						},
						"s": {
							"a": 0,
							"k": [100, 100]
						},
						"nm": "T",
						"sk": {
							"a": 0,
							"k": 0
						},
						"sa": {
							"a": 0,
							"k": 0
						}
					}
				]
			}
		],
		"ip": 0,
		"op": 720,
		"st": 0
	},
	{
		"ind": 26,
		"ty": 4,
		"nm": "W",
		"sr": 1,
		"ks": {
			"o": {
				"a": 0,
				"k": 100
			},
			"r": {
				"a": 1,
				"k": [
					{
						"i": {
							"x": [.833],
							"y": [.833]
						},
						"o": {
							"x": [.167],
							"y": [.167]
						},
						"t": 0,
						"s": [14]
					},
					{
						"i": {
							"x": [.833],
							"y": [.833]
						},
						"o": {
							"x": [.167],
							"y": [.167]
						},
						"t": 6,
						"s": [-9]
					},
					{
						"t": 25,
						"s": [29]
					}
				]
			},
			"p": {
				"k": [
					{
						"i": {
							"x": .667,
							"y": 1
						},
						"o": {
							"x": .333,
							"y": 0
						},
						"t": 0,
						"s": [
							610,
							290,
							0
						],
						"ti": [
							0,
							0,
							0
						],
						"to": [
							0,
							0,
							0
						]
					},
					{
						"i": {
							"x": .667,
							"y": 1
						},
						"o": {
							"x": .333,
							"y": 0
						},
						"t": 7,
						"s": [
							640,
							260,
							0
						],
						"ti": [
							0,
							0,
							0
						],
						"to": [
							0,
							0,
							0
						]
					},
					{
						"t": 35,
						"s": [
							610,
							290,
							0
						]
					}
				],
				"a": 1
			},
			"a": {
				"a": 0,
				"k": [
					80,
					-230,
					0
				]
			},
			"s": {
				"a": 0,
				"k": [
					100,
					100,
					100
				]
			}
		},
		"shapes": [{
			"ty": "gr",
			"nm": "W",
			"bm": 0,
			"it": [
				{
					"ty": "gr",
					"nm": "G",
					"bm": 0,
					"it": [
						{
							"ty": "sh",
							"nm": "P",
							"ind": 0,
							"ks": {
								"k": {
									"i": [
										[0, -3.711],
										[-.682, -1.406],
										[-4.969, 2.409],
										[-15.057, 1.905],
										[-13.441, -2.148],
										[-.872, 5.454],
										[5.454, .872],
										[15.366, -1.945],
										[15.274, -7.406]
									],
									"o": [
										[0, 1.464],
										[2.409, 4.969],
										[13.313, -6.455],
										[13.481, -1.705],
										[5.454, .871],
										[.864, -5.457],
										[-15.316, -2.447],
										[-17.22, 2.179],
										[-3.564, 1.729]
									],
									"v": [
										[-55.004, 6.997],
										[-54, 11.354],
										[-40.639, 15.989],
										[2.116, 3.39],
										[42.688, 4.055],
										[54.141, -4.242],
										[45.843, -15.695],
										[-.395, -16.453],
										[-49.365, -2.008]
									],
									"c": true
								},
								"a": 0
							}
						},
						{
							"ty": "fl",
							"nm": "F",
							"bm": 0,
							"c": {
								"a": 0,
								"k": [
									.211764720842,
									.250980392157,
									.286274509804,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"r": 1
						},
						{
							"ty": "tr",
							"o": {
								"a": 0,
								"k": 100
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [323.515, 135.119]
							},
							"a": {
								"a": 0,
								"k": [0, 0]
							},
							"s": {
								"a": 0,
								"k": [100, 100]
							},
							"nm": "T",
							"sk": {
								"a": 0,
								"k": 0
							},
							"sa": {
								"a": 0,
								"k": 0
							}
						}
					]
				},
				{
					"ty": "gr",
					"nm": "G",
					"bm": 0,
					"it": [
						{
							"ty": "sh",
							"nm": "P",
							"ind": 0,
							"ks": {
								"k": {
									"i": [
										[-64.07, -39.2],
										[-5.14, -13.32],
										[7.79, -13.91],
										[38.37, -5.19],
										[0, 0],
										[16.44, -8.01],
										[15.59, 1.47],
										[3.37, 4.85],
										[-1.06, 5.69],
										[-19.4, 18.33],
										[4.32, 4.53],
										[4.54, -4.32],
										[22.55, -12.65],
										[0, 0],
										[6.96, -3.17],
										[5.16, -.11],
										[6.74, 9.06],
										[-11.17, 12.02],
										[0, 0],
										[-29.08, 18.55]
									],
									"o": [
										[0, 0],
										[4.92, 12.75],
										[-16.72, 29.86],
										[-8.51, 1.15],
										[-18.12, 2.95],
										[-18.44, 9.16],
										[-9.17, -.95],
										[-4.22, -6.32],
										[22.44, -13.18],
										[4.42, -4.22],
										[-4.21, -4.43],
										[-19.28, 18.23],
										[0, 0],
										[-8.43, 4.85],
										[-4.74, 2.21],
										[-11.17, 0],
										[-9.7, -13.28],
										[0, 0],
										[12.86, -14.12],
										[88.2, -55.74]
									],
									"v": [
										[146.121, -41.406],
										[167.97, -17.656],
										[163.64, 22.513],
										[60.811, 64.013],
										[38.63, 66.083],
										[-12.79, 85.054],
										[-64.21, 101.284],
										[-82.97, 92.424],
										[-85.71, 71.143],
										[-22.69, 23.724],
										[-22.38, 7.814],
										[-38.19, 7.594],
										[-101.1, 54.284],
										[-101.2, 54.383],
										[-124.39, 66.404],
										[-139.14, 69.773],
										[-167.27, 55.333],
										[-164.75, 11.703],
										[-160.85, 7.383],
										[-101.31, -44.566]
									],
									"c": true
								},
								"a": 0
							}
						},
						{
							"ty": "sh",
							"nm": "P",
							"ind": 1,
							"ks": {
								"k": {
									"i": [
										[98.84, -62.6],
										[12.96, -14.22],
										[0, 0],
										[-.1, -13.81],
										[-7.27, -10.01],
										[-18.12, 0],
										[-7.59, 3.58],
										[-2.11, 1.05],
										[-4.53, -6.64],
										[-16.12, -1.58],
										[-22.297, 11.595],
										[-25.827, 3.055],
										[-21.277, 9.053],
										[-9.049, 11.234],
										[14.849, 24.659],
										[0, 0]
									],
									"o": [
										[-31.72, 20.13],
										[0, 0],
										[-9.9, 10.75],
										[0, 11.8],
										[10.75, 14.76],
										[8.54, -.11],
										[2, -.95],
										[.63, 6.74],
										[7.17, 10.96],
										[26.106, 2.513],
										[23.522, -13.052],
										[22.78, -3.272],
										[13.133, -5.688],
										[17.613, -22.028],
										[-5.13, -8.51],
										[-69.97, -44.68]
									],
									"v": [
										[-113.21, -63.427],
										[-177.39, -7.686],
										[-181.19, -3.466],
										[-196.15, 34.893],
										[-185.29, 68.503],
										[-139.14, 92.114],
										[-114.9, 86.633],
										[-108.58, 83.684],
										[-101.52, 104.654],
										[-66.43, 123.513],
										[6.887, 99.938],
										[73.078, 82.713],
										[140.171, 66.417],
										[174.668, 41.557],
										[181.4, -35.497],
										[162.24, -57.526]
									],
									"c": true
								},
								"a": 0
							}
						},
						{
							"ty": "mm",
							"nm": "M",
							"mm": 1
						},
						{
							"ty": "fl",
							"nm": "F",
							"bm": 0,
							"c": {
								"a": 0,
								"k": [
									.211764720842,
									.250980392157,
									.286274509804,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"r": 1
						},
						{
							"ty": "tr",
							"o": {
								"a": 0,
								"k": 100
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [280.05, 144.141]
							},
							"a": {
								"a": 0,
								"k": [0, 0]
							},
							"s": {
								"a": 0,
								"k": [100, 100]
							},
							"nm": "T",
							"sk": {
								"a": 0,
								"k": 0
							},
							"sa": {
								"a": 0,
								"k": 0
							}
						}
					]
				},
				{
					"ty": "gr",
					"nm": "W",
					"bm": 0,
					"it": [
						{
							"ty": "gr",
							"nm": "G",
							"bm": 0,
							"it": [
								{
									"ty": "sh",
									"nm": "P",
									"ind": 0,
									"ks": {
										"k": {
											"i": [
												[0, -3.711],
												[-.682, -1.406],
												[-4.969, 2.409],
												[-15.057, 1.905],
												[-13.441, -2.148],
												[-.872, 5.454],
												[5.454, .872],
												[15.366, -1.945],
												[15.274, -7.406]
											],
											"o": [
												[0, 1.464],
												[2.409, 4.969],
												[13.313, -6.455],
												[13.481, -1.705],
												[5.454, .871],
												[.864, -5.457],
												[-15.316, -2.447],
												[-17.22, 2.179],
												[-3.564, 1.729]
											],
											"v": [
												[-55.004, 6.997],
												[-54, 11.354],
												[-40.639, 15.989],
												[2.116, 3.39],
												[42.688, 4.055],
												[54.141, -4.242],
												[45.843, -15.695],
												[-.395, -16.453],
												[-49.365, -2.008]
											],
											"c": true
										},
										"a": 0
									}
								},
								{
									"ty": "fl",
									"nm": "F",
									"bm": 0,
									"c": {
										"a": 0,
										"k": [
											.211764720842,
											.250980392157,
											.286274509804,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1
								},
								{
									"ty": "tr",
									"o": {
										"a": 0,
										"k": 100
									},
									"r": {
										"a": 0,
										"k": 0
									},
									"p": {
										"a": 0,
										"k": [323.515, 135.119]
									},
									"a": {
										"a": 0,
										"k": [0, 0]
									},
									"s": {
										"a": 0,
										"k": [100, 100]
									},
									"nm": "T",
									"sk": {
										"a": 0,
										"k": 0
									},
									"sa": {
										"a": 0,
										"k": 0
									}
								}
							]
						},
						{
							"ty": "gr",
							"nm": "G",
							"bm": 0,
							"it": [
								{
									"ty": "sh",
									"nm": "P",
									"ind": 0,
									"ks": {
										"k": {
											"i": [
												[-64.07, -39.2],
												[-5.14, -13.32],
												[7.79, -13.91],
												[38.37, -5.19],
												[0, 0],
												[16.44, -8.01],
												[15.59, 1.47],
												[3.37, 4.85],
												[-1.06, 5.69],
												[-19.4, 18.33],
												[4.32, 4.53],
												[4.54, -4.32],
												[22.55, -12.65],
												[0, 0],
												[6.96, -3.17],
												[5.16, -.11],
												[6.74, 9.06],
												[-11.17, 12.02],
												[0, 0],
												[-29.08, 18.55]
											],
											"o": [
												[0, 0],
												[4.92, 12.75],
												[-16.72, 29.86],
												[-8.51, 1.15],
												[-18.12, 2.95],
												[-18.44, 9.16],
												[-9.17, -.95],
												[-4.22, -6.32],
												[22.44, -13.18],
												[4.42, -4.22],
												[-4.21, -4.43],
												[-19.28, 18.23],
												[0, 0],
												[-8.43, 4.85],
												[-4.74, 2.21],
												[-11.17, 0],
												[-9.7, -13.28],
												[0, 0],
												[12.86, -14.12],
												[88.2, -55.74]
											],
											"v": [
												[146.121, -41.406],
												[167.97, -17.656],
												[163.64, 22.513],
												[60.811, 64.013],
												[38.63, 66.083],
												[-12.79, 85.054],
												[-64.21, 101.284],
												[-82.97, 92.424],
												[-85.71, 71.143],
												[-22.69, 23.724],
												[-22.38, 7.814],
												[-38.19, 7.594],
												[-101.1, 54.284],
												[-101.2, 54.383],
												[-124.39, 66.404],
												[-139.14, 69.773],
												[-167.27, 55.333],
												[-164.75, 11.703],
												[-160.85, 7.383],
												[-101.31, -44.566]
											],
											"c": true
										},
										"a": 0
									}
								},
								{
									"ty": "sh",
									"nm": "P",
									"ind": 1,
									"ks": {
										"k": {
											"i": [
												[98.84, -62.6],
												[12.96, -14.22],
												[0, 0],
												[-.1, -13.81],
												[-7.27, -10.01],
												[-18.12, 0],
												[-7.59, 3.58],
												[-2.11, 1.05],
												[-4.53, -6.64],
												[-16.12, -1.58],
												[-22.297, 11.595],
												[-25.827, 3.055],
												[-21.277, 9.053],
												[-9.049, 11.234],
												[14.849, 24.659],
												[0, 0]
											],
											"o": [
												[-31.72, 20.13],
												[0, 0],
												[-9.9, 10.75],
												[0, 11.8],
												[10.75, 14.76],
												[8.54, -.11],
												[2, -.95],
												[.63, 6.74],
												[7.17, 10.96],
												[26.106, 2.513],
												[23.522, -13.052],
												[22.78, -3.272],
												[13.133, -5.688],
												[17.613, -22.028],
												[-5.13, -8.51],
												[-69.97, -44.68]
											],
											"v": [
												[-113.21, -63.427],
												[-177.39, -7.686],
												[-181.19, -3.466],
												[-196.15, 34.893],
												[-185.29, 68.503],
												[-139.14, 92.114],
												[-114.9, 86.633],
												[-108.58, 83.684],
												[-101.52, 104.654],
												[-66.43, 123.513],
												[6.887, 99.938],
												[73.078, 82.713],
												[140.171, 66.417],
												[174.668, 41.557],
												[181.4, -35.497],
												[162.24, -57.526]
											],
											"c": true
										},
										"a": 0
									}
								},
								{
									"ty": "mm",
									"nm": "M",
									"mm": 1
								},
								{
									"ty": "fl",
									"nm": "F",
									"bm": 0,
									"c": {
										"a": 0,
										"k": [
											.211764720842,
											.250980392157,
											.286274509804,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1
								},
								{
									"ty": "tr",
									"o": {
										"a": 0,
										"k": 100
									},
									"r": {
										"a": 0,
										"k": 0
									},
									"p": {
										"a": 0,
										"k": [280.05, 144.141]
									},
									"a": {
										"a": 0,
										"k": [0, 0]
									},
									"s": {
										"a": 0,
										"k": [100, 100]
									},
									"nm": "T",
									"sk": {
										"a": 0,
										"k": 0
									},
									"sa": {
										"a": 0,
										"k": 0
									}
								}
							]
						},
						{
							"ty": "tr",
							"o": {
								"a": 0,
								"k": 100
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [277.242, 155.312]
							},
							"a": {
								"a": 0,
								"k": [277.242, 155.312]
							},
							"s": {
								"a": 0,
								"k": [100, 100]
							},
							"nm": "T",
							"sk": {
								"a": 0,
								"k": 0
							},
							"sa": {
								"a": 0,
								"k": 0
							}
						}
					]
				},
				{
					"ty": "tr",
					"o": {
						"a": 0,
						"k": 100
					},
					"r": {
						"a": 0,
						"k": 0
					},
					"p": {
						"a": 0,
						"k": [-114.461, -231.11]
					},
					"a": {
						"a": 0,
						"k": [277.242, 155.312]
					},
					"s": {
						"a": 0,
						"k": [100, 100]
					},
					"nm": "T",
					"sk": {
						"a": 0,
						"k": 0
					},
					"sa": {
						"a": 0,
						"k": 0
					}
				}
			]
		}],
		"ip": 0,
		"op": 720,
		"st": 0
	},
	{
		"ind": 27,
		"ty": 4,
		"nm": "W",
		"sr": 1,
		"ks": {
			"o": {
				"a": 0,
				"k": 100
			},
			"r": {
				"a": 1,
				"k": [
					{
						"i": {
							"x": [.833],
							"y": [.833]
						},
						"o": {
							"x": [.167],
							"y": [.167]
						},
						"t": 0,
						"s": [14]
					},
					{
						"i": {
							"x": [.833],
							"y": [.833]
						},
						"o": {
							"x": [.167],
							"y": [.167]
						},
						"t": 6,
						"s": [-9]
					},
					{
						"t": 25,
						"s": [29]
					}
				]
			},
			"p": {
				"k": [
					{
						"i": {
							"x": .667,
							"y": 1
						},
						"o": {
							"x": .333,
							"y": 0
						},
						"t": 0,
						"s": [
							610,
							290,
							0
						],
						"ti": [
							0,
							0,
							0
						],
						"to": [
							0,
							0,
							0
						]
					},
					{
						"i": {
							"x": .667,
							"y": 1
						},
						"o": {
							"x": .333,
							"y": 0
						},
						"t": 7,
						"s": [
							640,
							260,
							0
						],
						"ti": [
							0,
							0,
							0
						],
						"to": [
							0,
							0,
							0
						]
					},
					{
						"t": 35,
						"s": [
							610,
							290,
							0
						]
					}
				],
				"a": 1
			},
			"a": {
				"a": 0,
				"k": [
					80,
					-230,
					0
				]
			},
			"s": {
				"a": 0,
				"k": [
					100,
					100,
					100
				]
			}
		},
		"shapes": [{
			"ty": "gr",
			"nm": "W",
			"bm": 0,
			"it": [
				{
					"ty": "gr",
					"nm": "G",
					"bm": 0,
					"it": [{
						"ty": "fl",
						"nm": "F",
						"bm": 0,
						"c": {
							"a": 0,
							"k": [
								1,
								1,
								1,
								1
							]
						},
						"o": {
							"a": 0,
							"k": 100
						},
						"r": 1
					}, {
						"ty": "tr",
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [323.515, 135.119]
						},
						"a": {
							"a": 0,
							"k": [0, 0]
						},
						"s": {
							"a": 0,
							"k": [100, 100]
						},
						"nm": "T",
						"sk": {
							"a": 0,
							"k": 0
						},
						"sa": {
							"a": 0,
							"k": 0
						}
					}]
				},
				{
					"ty": "gr",
					"nm": "W",
					"bm": 0,
					"it": [{
						"ty": "gr",
						"nm": "G",
						"bm": 0,
						"it": [
							{
								"ty": "sh",
								"nm": "P",
								"ind": 0,
								"ks": {
									"k": {
										"i": [
											[-64.07, -39.2],
											[-5.14, -13.32],
											[7.79, -13.91],
											[38.37, -5.19],
											[0, 0],
											[16.44, -8.01],
											[15.59, 1.47],
											[3.37, 4.85],
											[-1.06, 5.69],
											[-19.4, 18.33],
											[4.32, 4.53],
											[4.54, -4.32],
											[22.55, -12.65],
											[0, 0],
											[6.96, -3.17],
											[5.16, -.11],
											[6.74, 9.06],
											[-11.17, 12.02],
											[0, 0],
											[-29.08, 18.55]
										],
										"o": [
											[0, 0],
											[4.92, 12.75],
											[-16.72, 29.86],
											[-8.51, 1.15],
											[-18.12, 2.95],
											[-18.44, 9.16],
											[-9.17, -.95],
											[-4.22, -6.32],
											[22.44, -13.18],
											[4.42, -4.22],
											[-4.21, -4.43],
											[-19.28, 18.23],
											[0, 0],
											[-8.43, 4.85],
											[-4.74, 2.21],
											[-11.17, 0],
											[-9.7, -13.28],
											[0, 0],
											[12.86, -14.12],
											[88.2, -55.74]
										],
										"v": [
											[146.121, -41.406],
											[167.97, -17.656],
											[163.64, 22.513],
											[60.811, 64.013],
											[38.63, 66.083],
											[-12.79, 85.054],
											[-64.21, 101.284],
											[-82.97, 92.424],
											[-85.71, 71.143],
											[-22.69, 23.724],
											[-22.38, 7.814],
											[-38.19, 7.594],
											[-101.1, 54.284],
											[-101.2, 54.383],
											[-124.39, 66.404],
											[-139.14, 69.773],
											[-167.27, 55.333],
											[-164.75, 11.703],
											[-160.85, 7.383],
											[-101.31, -44.566]
										],
										"c": true
									},
									"a": 0
								}
							},
							{
								"ty": "fl",
								"nm": "F",
								"bm": 0,
								"c": {
									"a": 0,
									"k": [
										1,
										1,
										1,
										1
									]
								},
								"o": {
									"a": 0,
									"k": 100
								},
								"r": 1
							},
							{
								"ty": "tr",
								"o": {
									"a": 0,
									"k": 100
								},
								"r": {
									"a": 0,
									"k": 0
								},
								"p": {
									"a": 0,
									"k": [280.05, 144.141]
								},
								"a": {
									"a": 0,
									"k": [0, 0]
								},
								"s": {
									"a": 0,
									"k": [100, 100]
								},
								"nm": "T",
								"sk": {
									"a": 0,
									"k": 0
								},
								"sa": {
									"a": 0,
									"k": 0
								}
							}
						]
					}, {
						"ty": "tr",
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [277.242, 155.312]
						},
						"a": {
							"a": 0,
							"k": [277.242, 155.312]
						},
						"s": {
							"a": 0,
							"k": [100, 100]
						},
						"nm": "T",
						"sk": {
							"a": 0,
							"k": 0
						},
						"sa": {
							"a": 0,
							"k": 0
						}
					}]
				},
				{
					"ty": "tr",
					"o": {
						"a": 0,
						"k": 100
					},
					"r": {
						"a": 0,
						"k": 0
					},
					"p": {
						"a": 0,
						"k": [-114.461, -231.11]
					},
					"a": {
						"a": 0,
						"k": [277.242, 155.312]
					},
					"s": {
						"a": 0,
						"k": [100, 100]
					},
					"nm": "T",
					"sk": {
						"a": 0,
						"k": 0
					},
					"sa": {
						"a": 0,
						"k": 0
					}
				}
			]
		}],
		"ip": 0,
		"op": 720,
		"st": 0
	},
	{
		"ind": 28,
		"ty": 4,
		"nm": "W",
		"sr": 1,
		"ks": {
			"o": {
				"a": 0,
				"k": 100
			},
			"r": {
				"a": 1,
				"k": [
					{
						"i": {
							"x": [.667],
							"y": [1]
						},
						"o": {
							"x": [.333],
							"y": [0]
						},
						"t": 0,
						"s": [-14]
					},
					{
						"i": {
							"x": [.667],
							"y": [1]
						},
						"o": {
							"x": [.333],
							"y": [0]
						},
						"t": 6,
						"s": [9]
					},
					{
						"t": 25,
						"s": [-29]
					}
				]
			},
			"p": {
				"k": [
					{
						"i": {
							"x": .667,
							"y": 1
						},
						"o": {
							"x": .333,
							"y": 0
						},
						"t": 0,
						"s": [
							780,
							460,
							0
						],
						"ti": [
							0,
							0,
							0
						],
						"to": [
							0,
							0,
							0
						]
					},
					{
						"i": {
							"x": .667,
							"y": 1
						},
						"o": {
							"x": .333,
							"y": 0
						},
						"t": 7,
						"s": [
							810,
							430,
							0
						],
						"ti": [
							0,
							0,
							0
						],
						"to": [
							0,
							0,
							0
						]
					},
					{
						"t": 35,
						"s": [
							780,
							460,
							0
						]
					}
				],
				"a": 1
			},
			"a": {
				"a": 0,
				"k": [
					638,
					306,
					0
				]
			},
			"s": {
				"a": 0,
				"k": [
					100,
					100,
					100
				]
			}
		},
		"shapes": [{
			"ty": "gr",
			"nm": "W",
			"bm": 0,
			"it": [
				{
					"ty": "gr",
					"nm": "G",
					"bm": 0,
					"it": [
						{
							"ty": "sh",
							"nm": "P",
							"ind": 0,
							"ks": {
								"k": {
									"i": [
										[3.711, 0],
										[1.406, .682],
										[-2.409, 4.969],
										[-1.905, 15.057],
										[2.148, 13.441],
										[-5.454, .872],
										[-.872, -5.454],
										[1.945, -15.366],
										[7.406, -15.274]
									],
									"o": [
										[-1.464, 0],
										[-4.969, -2.409],
										[6.455, -13.313],
										[1.705, -13.481],
										[-.871, -5.454],
										[5.457, -.864],
										[2.447, 15.316],
										[-2.179, 17.22],
										[-1.729, 3.564]
									],
									"v": [
										[-6.997, 55.004],
										[-11.354, 54],
										[-15.989, 40.639],
										[-3.39, -2.116],
										[-4.055, -42.688],
										[4.242, -54.141],
										[15.695, -45.843],
										[16.453, .395],
										[2.008, 49.365]
									],
									"c": true
								},
								"a": 0
							}
						},
						{
							"ty": "fl",
							"nm": "F",
							"bm": 0,
							"c": {
								"a": 0,
								"k": [
									.211764720842,
									.250980392157,
									.286274509804,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"r": 1
						},
						{
							"ty": "tr",
							"o": {
								"a": 0,
								"k": 100
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [657.115, 452.48]
							},
							"a": {
								"a": 0,
								"k": [0, 0]
							},
							"s": {
								"a": 0,
								"k": [100, 100]
							},
							"nm": "T",
							"sk": {
								"a": 0,
								"k": 0
							},
							"sa": {
								"a": 0,
								"k": 0
							}
						}
					]
				},
				{
					"ty": "gr",
					"nm": "G",
					"bm": 0,
					"it": [
						{
							"ty": "sh",
							"nm": "P",
							"ind": 0,
							"ks": {
								"k": {
									"i": [
										[55.74, -88.2],
										[14.12, -12.86],
										[0, 0],
										[13.28, 9.7],
										[0, 11.17],
										[-2.21, 4.74],
										[-4.85, 8.43],
										[0, 0],
										[-18.23, 19.28],
										[4.43, 4.21],
										[4.22, -4.42],
										[13.18, -22.44],
										[6.32, 4.22],
										[.95, 9.17],
										[-9.16, 18.44],
										[-2.95, 18.12],
										[-1.15, 8.51],
										[-29.86, 16.72],
										[-12.75, -4.92],
										[0, 0]
									],
									"o": [
										[-18.55, 29.08],
										[0, 0],
										[-12.02, 11.17],
										[-9.06, -6.74],
										[.11, -5.16],
										[3.17, -6.96],
										[0, 0],
										[12.65, -22.55],
										[4.32, -4.54],
										[-4.53, -4.32],
										[-18.33, 19.4],
										[-5.69, 1.06],
										[-4.85, -3.37],
										[-1.47, -15.59],
										[8.01, -16.44],
										[0, 0],
										[5.19, -38.37],
										[13.91, -7.79],
										[13.32, 5.14],
										[39.2, 64.07]
									],
									"v": [
										[44.567, 101.309],
										[-7.383, 160.85],
										[-11.703, 164.749],
										[-55.333, 167.27],
										[-69.773, 139.139],
										[-66.403, 124.39],
										[-54.383, 101.2],
										[-54.283, 101.099],
										[-7.593, 38.189],
										[-7.813, 22.379],
										[-23.723, 22.689],
										[-71.143, 85.71],
										[-92.423, 82.97],
										[-101.283, 64.21],
										[-85.053, 12.789],
										[-66.083, -38.631],
										[-64.013, -60.811],
										[-22.513, -163.641],
										[17.657, -167.97],
										[41.407, -146.121]
									],
									"c": true
								},
								"a": 0
							}
						},
						{
							"ty": "sh",
							"nm": "P",
							"ind": 1,
							"ks": {
								"k": {
									"i": [
										[44.68, 69.97],
										[8.51, 5.13],
										[22.028, -17.613],
										[5.688, -13.133],
										[3.272, -22.78],
										[13.052, -23.522],
										[-2.513, -26.106],
										[-10.96, -7.17],
										[-6.74, -.63],
										[.95, -2],
										[.11, -8.54],
										[-14.76, -10.75],
										[-11.8, 0],
										[-10.75, 9.9],
										[0, 0],
										[-20.13, 31.72]
									],
									"o": [
										[0, 0],
										[-24.659, -14.849],
										[-11.234, 9.049],
										[-9.053, 21.277],
										[-3.055, 25.827],
										[-11.595, 22.297],
										[1.58, 16.12],
										[6.64, 4.53],
										[-1.05, 2.11],
										[-3.58, 7.59],
										[0, 18.12],
										[10.01, 7.27],
										[13.81, .1],
										[0, 0],
										[14.22, -12.96],
										[62.6, -98.84]
									],
									"v": [
										[57.527, -162.241],
										[35.497, -181.4],
										[-41.557, -174.668],
										[-66.417, -140.172],
										[-82.712, -73.079],
										[-99.938, -6.888],
										[-123.513, 66.429],
										[-104.653, 101.52],
										[-83.683, 108.58],
										[-86.633, 114.9],
										[-92.113, 139.139],
										[-68.503, 185.29],
										[-34.893, 196.15],
										[3.467, 181.189],
										[7.687, 177.389],
										[63.427, 113.21]
									],
									"c": true
								},
								"a": 0
							}
						},
						{
							"ty": "mm",
							"nm": "M",
							"mm": 1
						},
						{
							"ty": "fl",
							"nm": "F",
							"bm": 0,
							"c": {
								"a": 0,
								"k": [
									.211764720842,
									.250980392157,
									.286274509804,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"r": 1
						},
						{
							"ty": "tr",
							"o": {
								"a": 0,
								"k": 100
							},
							"r": {
								"a": 0,
								"k": 0
							},
							"p": {
								"a": 0,
								"k": [648.093, 495.945]
							},
							"a": {
								"a": 0,
								"k": [0, 0]
							},
							"s": {
								"a": 0,
								"k": [100, 100]
							},
							"nm": "T",
							"sk": {
								"a": 0,
								"k": 0
							},
							"sa": {
								"a": 0,
								"k": 0
							}
						}
					]
				},
				{
					"ty": "tr",
					"o": {
						"a": 0,
						"k": 100
					},
					"r": {
						"a": 0,
						"k": 0
					},
					"p": {
						"a": 0,
						"k": [636.922, 498.753]
					},
					"a": {
						"a": 0,
						"k": [636.922, 498.753]
					},
					"s": {
						"a": 0,
						"k": [100, 100]
					},
					"nm": "T",
					"sk": {
						"a": 0,
						"k": 0
					},
					"sa": {
						"a": 0,
						"k": 0
					}
				}
			]
		}],
		"ip": 0,
		"op": 720,
		"st": 0
	},
	{
		"ind": 29,
		"ty": 4,
		"nm": "W",
		"sr": 1,
		"ks": {
			"o": {
				"a": 0,
				"k": 100
			},
			"r": {
				"a": 1,
				"k": [
					{
						"i": {
							"x": [.667],
							"y": [1]
						},
						"o": {
							"x": [.333],
							"y": [0]
						},
						"t": 0,
						"s": [-14]
					},
					{
						"i": {
							"x": [.667],
							"y": [1]
						},
						"o": {
							"x": [.333],
							"y": [0]
						},
						"t": 6,
						"s": [9]
					},
					{
						"t": 25,
						"s": [-29]
					}
				]
			},
			"p": {
				"k": [
					{
						"i": {
							"x": .667,
							"y": 1
						},
						"o": {
							"x": .333,
							"y": 0
						},
						"t": 0,
						"s": [
							780,
							460,
							0
						],
						"ti": [
							0,
							0,
							0
						],
						"to": [
							0,
							0,
							0
						]
					},
					{
						"i": {
							"x": .667,
							"y": 1
						},
						"o": {
							"x": .333,
							"y": 0
						},
						"t": 7,
						"s": [
							810,
							430,
							0
						],
						"ti": [
							0,
							0,
							0
						],
						"to": [
							0,
							0,
							0
						]
					},
					{
						"t": 35,
						"s": [
							780,
							460,
							0
						]
					}
				],
				"a": 1
			},
			"a": {
				"a": 0,
				"k": [
					638,
					306,
					0
				]
			},
			"s": {
				"a": 0,
				"k": [
					100,
					100,
					100
				]
			}
		},
		"shapes": [{
			"ty": "gr",
			"nm": "W",
			"bm": 0,
			"it": [{
				"ty": "gr",
				"nm": "G",
				"bm": 0,
				"it": [
					{
						"ty": "sh",
						"nm": "P",
						"ind": 0,
						"ks": {
							"k": {
								"i": [
									[55.74, -88.2],
									[14.12, -12.86],
									[0, 0],
									[13.28, 9.7],
									[0, 11.17],
									[-2.21, 4.74],
									[-4.85, 8.43],
									[0, 0],
									[-18.23, 19.28],
									[4.43, 4.21],
									[4.22, -4.42],
									[13.18, -22.44],
									[6.32, 4.22],
									[.95, 9.17],
									[-9.16, 18.44],
									[-2.95, 18.12],
									[-1.15, 8.51],
									[-29.86, 16.72],
									[-12.75, -4.92],
									[0, 0]
								],
								"o": [
									[-18.55, 29.08],
									[0, 0],
									[-12.02, 11.17],
									[-9.06, -6.74],
									[.11, -5.16],
									[3.17, -6.96],
									[0, 0],
									[12.65, -22.55],
									[4.32, -4.54],
									[-4.53, -4.32],
									[-18.33, 19.4],
									[-5.69, 1.06],
									[-4.85, -3.37],
									[-1.47, -15.59],
									[8.01, -16.44],
									[0, 0],
									[5.19, -38.37],
									[13.91, -7.79],
									[13.32, 5.14],
									[39.2, 64.07]
								],
								"v": [
									[44.567, 101.309],
									[-7.383, 160.85],
									[-11.703, 164.749],
									[-55.333, 167.27],
									[-69.773, 139.139],
									[-66.403, 124.39],
									[-54.383, 101.2],
									[-54.283, 101.099],
									[-7.593, 38.189],
									[-7.813, 22.379],
									[-23.723, 22.689],
									[-71.143, 85.71],
									[-92.423, 82.97],
									[-101.283, 64.21],
									[-85.053, 12.789],
									[-66.083, -38.631],
									[-64.013, -60.811],
									[-22.513, -163.641],
									[17.657, -167.97],
									[41.407, -146.121]
								],
								"c": true
							},
							"a": 0
						}
					},
					{
						"ty": "fl",
						"nm": "F",
						"bm": 0,
						"c": {
							"a": 0,
							"k": [
								1,
								1,
								1,
								1
							]
						},
						"o": {
							"a": 0,
							"k": 100
						},
						"r": 1
					},
					{
						"ty": "tr",
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [648.093, 495.945]
						},
						"a": {
							"a": 0,
							"k": [0, 0]
						},
						"s": {
							"a": 0,
							"k": [100, 100]
						},
						"nm": "T",
						"sk": {
							"a": 0,
							"k": 0
						},
						"sa": {
							"a": 0,
							"k": 0
						}
					}
				]
			}, {
				"ty": "tr",
				"o": {
					"a": 0,
					"k": 100
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [636.922, 498.753]
				},
				"a": {
					"a": 0,
					"k": [636.922, 498.753]
				},
				"s": {
					"a": 0,
					"k": [100, 100]
				},
				"nm": "T",
				"sk": {
					"a": 0,
					"k": 0
				},
				"sa": {
					"a": 0,
					"k": 0
				}
			}]
		}],
		"ip": 0,
		"op": 720,
		"st": 0
	}
];
var markers = [];
var flying_money_gt_default = {
	v,
	ip: 0,
	op: 37,
	fr: 24,
	w,
	h,
	nm: "F",
	assets,
	layers,
	markers
};
//#endregion
export { assets, flying_money_gt_default as default, h, layers, markers, v, w };

//# sourceMappingURL=flying-money-gt.js.map